import BaseComponent from '../abstracts/BaseComponent';

export default class TabsComponent extends BaseComponent {
  get SELECTORS() {
    return {
      triggers: '.js-panel-trigger',
      panels: '.js-tab-panel'
    };
  }

  get CLASSES() {
    return {
      active: 'active',
      visible: 'visible'
    };
  }

  constructor(props) {
    super(props);
    this.timeout = null;
    this.handleClick();
    this.selectTabByUrl();
  }

  selectTabByUrl() {
    const { hash } = window.location;
    if (hash) {
      const currentTarget = document.querySelector(`[href="${hash.split('?')[0]}"]`);
      if (currentTarget) {
        const triggers = this.$el.querySelectorAll(this.SELECTORS.triggers);
        const panels = this.$el.querySelectorAll(this.SELECTORS.panels);
        this.handleTabs(currentTarget, triggers, panels);
      }
    }
  }

  handleTabs(currentTarget, triggers, panels) {
    clearTimeout(this.timeout);
    const targetByAttribute = this.$el.querySelector(`[data-panel-id="${currentTarget.getAttribute('href')}"]`);
    const target = targetByAttribute || this.$el.querySelector(currentTarget.getAttribute('href'));

    // PITTI20-609
    if (!target) {
      return;
    }

    triggers.forEach(el => el.classList.remove(this.CLASSES.active));
    triggers.forEach(el => el.setAttribute('aria-selected', 'false'));
    panels.forEach(el => el.classList.remove(this.CLASSES.active));
    panels.forEach(el => el.setAttribute('aria-hidden', 'true'));

    currentTarget.classList.add(this.CLASSES.active);
    currentTarget.setAttribute('aria-selected', 'true');
    if (target) {
      target.classList.add(this.CLASSES.active);
      target.setAttribute('aria-hidden', 'false');

      this.timeout = setTimeout(() => {
        target.classList.add(this.CLASSES.visible);
      }, 100);
    }

  }

  handleClick() {
    const triggers = this.$el.querySelectorAll(this.SELECTORS.triggers);
    const panels = this.$el.querySelectorAll(this.SELECTORS.panels);
    triggers.forEach((trigger) => {
      this.$on('click.tabs', (e) => {
        e.preventDefault();
        this.handleTabs(e.currentTarget, triggers, panels);
      }, trigger);
    });
  }
}
